import React, { useContext, useEffect } from 'react';
import { Heading, Button } from '@americanexpress/dls-react';
import {
    CompanyDetail,
    Citizenship,
    Error,
    Mobile,
    ResidentStatus,
    ResidenceType,
    ApplicationSave,
    Journey1,
    Journey2,
    Journey3,
    Journey4
} from '../../components';
import userContext from '../../components/ContextComponent/UserContext';
import Student from '../../components/Student/Student';
import { CONSTANTS } from '../../constants';

function StageTwoForm(props) {
    const { formData } = useContext(userContext);
    const { errorData, setErrorData } = useContext(userContext);

    useEffect(() => {
        window.setITag("page2load", "success", "23643");
        window.setPageContext("AdditionalInfo");
    }, []);

    const handleOnClick = (e) => {
        // Generic Validations
        if (formData.alternateMobileNumber === '') {
            setErrorData({ ...errorData, altNumberRequired: true });
        }
        else if (formData.residentTypeID === 0) {
            setErrorData({ ...errorData, residenceTypeRequired: true });
        }
        else if (formData.residentStatusCode === '') {
            setErrorData({ ...errorData, residenceStatusRequired: true });
        }
        // Student Specific Validations
        else if (formData.employmentStatus === CONSTANTS.employmentStatus.student
            && formData.schoolID === 0) {
            setErrorData({ ...errorData, schoolRequired: true });
        }
        else if (formData.employmentStatus === CONSTANTS.employmentStatus.student && formData.schoolEmail === '') {
            setErrorData({ ...errorData, emailRequired: true });
        }
        // Company Validations
        else if (formData.employmentStatus === CONSTANTS.employmentStatus.salariedPvtSector
            || formData.employmentStatus === CONSTANTS.employmentStatus.salariedPublicSector
            || formData.employmentStatus === CONSTANTS.employmentStatus.professional
            || formData.employmentStatus === CONSTANTS.employmentStatus.selfEmployed
            || formData.employmentStatus === CONSTANTS.employmentStatus.retired) {
            if (formData.companyName === '') {
                setErrorData({ ...errorData, companyNameRequired: true });
            }
            if (formData.industry === '') {
                setErrorData({ ...errorData, industryRequired: true });
            }
            if (formData.OfficeAddressLine1 === '' || !CONSTANTS.validation.addressPattern.test(formData.OfficeAddressLine1)) {
                setErrorData({ ...errorData, OfficeAddressLine1Required: true });
            }
            if (formData.OfficeAddressLine2 === '' || !CONSTANTS.validation.addressPattern.test(formData.OfficeAddressLine2)) {
                setErrorData({ ...errorData, OfficeAddressLine2Required: true });
            }
            if (formData.OfficeAddressLine3 === '' || !CONSTANTS.validation.addressPattern.test(formData.OfficeAddressLine3)) {
                setErrorData({ ...errorData, OfficeAddressLine3Required: true });
            }
            if (formData.CompanyAddressPincode === '') {
                setErrorData({ ...errorData, CompanyAddressPincodeRequired: true });
            }
            if (formData.companyAddressCity === '') {
                setErrorData({ ...errorData, companyAddressCityRequired: true });
            }
            if (formData.companyAddressState === undefined || formData.companyAddressState === '') {
                setErrorData({ ...errorData, companyAddressStateRequired: true });
            }
        }
        else if (formData.employmentStatus === CONSTANTS.employmentStatus.salariedPvtSector
            || formData.employmentStatus === CONSTANTS.employmentStatus.salariedPublicSector
            || formData.employmentStatus === CONSTANTS.employmentStatus.professional
            || formData.employmentStatus === CONSTANTS.employmentStatus.selfEmployed) {
            if (formData.companyEmail === '') {
                setErrorData((previousStateValue) => {return { ...previousStateValue, emailRequired: true }
        });
            }
        }
        else {
            setErrorData({
                ...errorData, schoolRequired: false,
                companyNameRequired: false,
                industryRequired: false,
                OfficeAddressLine1Required: false,
                OfficeAddressLine2Required: false,
                OfficeAddressLine3Required: false,
                CompanyAddressPincodeRequired: false,
                emailRequired: false,
                altNumberRequired: false,
                residenceTypeRequired: false,
                residenceStatusRequired: false,
                companyAddressCityRequired: false,
                companyAddressStateRequired: false
            });
        }
    }

    const showCompanyDetail = () => {
        if (formData.employmentStatus === CONSTANTS.employmentStatus.salariedPvtSector ||
            formData.employmentStatus === CONSTANTS.employmentStatus.salariedPublicSector ||
            formData.employmentStatus === CONSTANTS.employmentStatus.professional ||
            formData.employmentStatus === CONSTANTS.employmentStatus.selfEmployed ||
            formData.employmentStatus === CONSTANTS.employmentStatus.retired ||
            formData.employmentStatus === ""
        )
            return <CompanyDetail/>
    }
    return (
        <>
            <form onSubmit={props.handleSubmit}>
                <div className="pad-responsive">
                    <div className="stack body">
                        {props.data && (
                            <div className="stack-a">
                                <Error errorList={props.validation} />
                                {/*<Error errorList={props.data.errors} /> Commented by shashi - not working*/}
                                <Heading level={3} headingStyle="heading3" className="margin-2-b">
                                    {
                                        (props.apiOutput?.journeyName === CONSTANTS.go2Journey.Journey1) &&
                                        <Journey1 props={props} />
                                    }
                                    {
                                        (props.apiOutput?.journeyName === CONSTANTS.go2Journey.Journey2) &&
                                        <Journey2 props={props} />
                                    }
                                    {
                                        (props.apiOutput?.journeyName === CONSTANTS.go2Journey.Journey3) &&
                                        <Journey3 props={props} />
                                    }
                                    {
                                        (props.apiOutput?.journeyName === CONSTANTS.go2Journey.Journey4) &&
                                        <Journey4 />
                                    }
                                </Heading>
                                <ApplicationSave />
                            </div>
                        )}
                        <div className="row stack">
                            {formData.employmentStatus === CONSTANTS.employmentStatus.student &&
                                <Student />
                            }
                            {showCompanyDetail()}                        
                        </div>
                        <Heading level={3} headingStyle="heading3" className="margin-2-b text-uppercase">Additional Information </Heading>
                        <div className="row">
                            <div className="col-md-6">
                                <Mobile format={"##########"} type={"Alternate"} />
                            </div>
                            <div className="col-md-6">
                                <Citizenship />
                            </div>
                        </div>
                        <div className="row stack">
                            <div className="col-md-6">
                                <ResidenceType />
                            </div>
                            <div className="col-md-6">
                                <ResidentStatus />
                            </div>
                        </div>
                    </div>
                </div>
                {
                    (props.apiOutput?.go2ApiCreditLevel === "SUPER_PASS") &&
                        <div>
                            <p className="body-1 pad-2-l"><sup>1</sup>The above is indicative and may change during application processing.</p>
                        </div>
                }
                <div className="flex flex-column flex-align-items-center pad-responsive">
                    <Button aria-label="Submit" type="submit" styleType="primary" onClick={handleOnClick} >Save and continue</Button>
                </div>
            </form>
        </>
    );
}

export default StageTwoForm;
